import React from 'react';
const CustomLogoInputDisplay = (props) => {
    return (
        <span>
            <div>Existing Image</div>
            {props.record[props.field] && <img src={props.record[props.field]} />}
        </span>
    )
};
export default CustomLogoInputDisplay;